import { find, findKey, filter } from 'lodash';

class StockFormController {

    constructor($scope, $state, availabilityModelService, messageService, time, currentPropertyService) {
        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.time = time;
        this.currentPropertyService = currentPropertyService;
    }

    $onInit () {
        this.quantity = this.stock || [];

        this.property = this.currentPropertyService.get();
        this.eventTypes = [
            {
                id: 0,
                name: 'Spa Days',
                type_name: 'spadays',
                search: 'SpaDay',
                disabled: !(this.events.SpaDay && this.events.SpaDay.length)
            },
            {
                id: 0,
                name: 'Treatments',
                type_name: 'treatments',
                search: 'Treatment',
                disabled: !(this.events.Treatment && this.events.Treatment.length)
            }
        ];

        this.today = moment();

        this.categories = filter(this.categories, (item) => item.spadays.length || item.treatments.length);
        if (!this.categories.length) this.categories = [{
            id: -1,
            name: 'No Valid Categories',
            type_name: 'na'
        }];

        if (this.stock) {
            this.event_type = 'App\\Event';
            if (this.events) {
                this.event = find(this.determineList(), { id: this.stock[0].event_id, type_raw: this.stock[0].event_type });
                this.start = moment(this.stock[0].date) || this.today;
            }
        }
    }

    determineList () {
        switch (this.event_type) {
            case 'App\\EventCategory':
                return this.categories;

            case 'App\\Event':
                if (this.events.SpaDay) {
                    return this.events.SpaDay.concat(this.events.Treatment);
                }
                return this.events.Treatment;

            case 'App\\EventType':
                return this.eventTypes;
        }
    }

    noPrevious () {
        if (this.today && this.start) {
            return this.today.format('YYYY-MM-DD') >= this.start.format('YYYY-MM-DD');
        }
    }

    groupBy (item) {
        return item.type_display;
    }

    filter () {
        if (this.start) {
            let event = this.event ? {
                type: this.event.type_name.toLowerCase(),
                id: this.event.id,
                date: this.start.format('YYYY-MM-DD')
            } : {
                    type: '*',
                    date: this.start.format('YYYY-MM-DD')
                };

            this.loading = true;
            this.quantity = [];
            this.availabilityModelService.getStock(event).then(response => {
                this.createList();
                this.blocks = response.blocks;
                response = response.events;
                for (let i = 0, l = response.length; i < l; i++) {
                    let found = event.type === '*' ? 0 : findKey(this.quantity, { event_id: response[i].event_id, event_type: response[i].event_type });
                    if (found !== undefined) {
                        this.quantity[found].quantity = response[i].quantity;
                        this.quantity[found].limited = response[i].limited;
                    }
                }
                this.loading = false;
            });
        }
    }

    updateWait (item) {
        if (item.quantity.match(/[^0-9]+/g)) return;
        item.updating = false;
        clearTimeout(item.trigger);
        item.trigger = setTimeout(() => { this.trigger(item); }, 500);
    }

    update (item) {
        this.trigger(item);
    }

    trigger (item) {
        item.trigger = undefined;
        item.updating = true;

        let date = this.start || moment(this.stock[0].date);
        this.availabilityModelService.updateStock(item, date.format('YYYY-MM-DD')).then(() => {
            item.updating = false;
        });
    }

    traverseDays (modifier) {
        this.start.add(modifier, "days");
    }

    createList () {
        let items = [];
        switch (this.event_type) {
            case '*':
                this.quantity = [{
                    event_id: undefined,
                    event_type: undefined,
                    name: 'Global Quantity',
                    type: undefined,
                    base_quantity: this.property.global_quantity,
                    quantity: this.property.global_quantity,
                    track_quantity: true
                }];
                break;

            case 'App\\EventCategory':
                items = this.event.spadays.concat(this.event.treatments).map(element => {
                    let item = {
                        event_id: element.related_event.id,
                        event_type: element.related_event.type_raw,
                        name: element.related_event.name,
                        type: element.related_event.type_display,
                        base_quantity: element.related_event.base_quantity,
                        track_quantity: element.related_event.track_quantity
                    };
                    return item;
                });
                this.quantity = items;
                break;

            case 'App\\Event':
                this.quantity = [{
                    event_id: this.event.id,
                    event_type: this.event.type_raw,
                    name: this.event.name,
                    type: this.event.type_display,
                    base_quantity: this.event.base_quantity,
                    track_quantity: this.event.track_quantity
                }];
                break;

            case 'App\\EventType':
                items = this.events[this.event.search].map(element => {
                    let item = {
                        event_id: element.id,
                        event_type: element.type_raw,
                        name: element.name,
                        type: element.type_display,
                        base_quantity: element.base_quantity,
                        track_quantity: element.track_quantity
                    };
                    return item;
                });
                this.quantity = items;
        }
    }
}

StockFormController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'time', 'currentPropertyService'];

export default StockFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/stock.form.controller.js